/** Third-party AI consent (decision D-7): `GET` / `POST /user/ai-consent`. See src/native/aiConsent.ts. */
import httpClient from './auth-http-client'
import { type AiConsentStatus, parseAiConsentStatus } from '@/native/aiConsent'

/** Null when the status could not be read (offline, or a backend without the endpoint). */
export async function getAiConsent(): Promise<AiConsentStatus | null> {
    const res: any = await httpClient.get('/user/ai-consent')
    if (res?.status !== 200) return null
    return parseAiConsentStatus(res.data)
}

export async function postAiConsent(version: string, accepted: boolean): Promise<AiConsentStatus | null> {
    const res: any = await httpClient.post('/user/ai-consent', { version, accepted })
    if (res?.status !== 200) return null
    return parseAiConsentStatus(res.data)
}
